import React from 'react';
import _ from 'lodash';

import NewEntry from './NewEntry';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Table from '../../Components/Table';
import Loader from '../../Components/Loader';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete } from '../../Redux/Actions'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';

import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

const ENDPOINT = "betriebsstaetten"

const styles = theme => ({

})

const columns = [
    "Name"
];


class ListObject extends Master {

    state = {
        ...this.state,
        isLoading: true,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT
    }

    componentDidMount() {
        document.title = "Betriebsstätte"
        this.props.doLoad()
        this.unsubscribe = store.subscribe(() => {
                var generic = select(store.getState(), ENDPOINT)
                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }
                if(_.has(generic, "dialogOpen") && this.state.dialogOpen !== generic.dialogOpen) {
                    this.setState({
                        dialogOpen: generic.dialogOpen
                    })
                }
            }
        )
    }

    render() {

        var { classes } = this.props
        var { newEntry, isLoading, dialogOpen, newEntry } = this.state

        if(isLoading) {
            return (
                <Loader />
            )
        }

        var items = []
        var count = 0
        var page = 0
        
        if(_.has(this.props, ENDPOINT + '.data') && this.props[ENDPOINT].data.length > 0) {
            this.props[ENDPOINT].data.forEach((item) => {
                items.push([
                    item.name ? item.name : "-",
                    item.id
                ])
            })
            count = this.props[ENDPOINT].count
            page = this.props[ENDPOINT].page
        }

        return (
            <div>

                <TextField
                    placeholder="Suchen"
                    type="search"
                    margin="normal"
                    fullWidth
                    autoFocus
                    onChange={this.search()}
                />

                <Table
                    title="Betriebsstätten"
                    key={ENDPOINT+items.length}
                    data={items}
                    count={count}
                    columns={columns}
                    currentPage={page}
                    populate={this.populate}
                    onDelete={this.deleteAction}
                    rowClick={this.gotoToDetail}
                    options={{
                        selectableRows: false
                    }}
                />

                <NewEntry handleClickOpen={this.handleClickOpen} dialogOpen={this.state.dialogOpen} />
                <Button variant="fab" className="fab" onClick={this.handleClickOpen} color={"primary"}>
                    <AddIcon />
                </Button>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    doSearch: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    //doPost: (data) => dispatch(doPost("pakete", "api/generic/pakete", data)),
    doDelete: (id) => dispatch(doDelete(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, id)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Betriebsstaetten/index.js